// Card time estimates are stored as whole minutes.

// 90 -> "1h 30m", 60 -> "1h", 45 -> "45m"
export const formatEstimate = (minutes) => {
  const m = Number(minutes);
  if (!m || m <= 0) return '';
  const h = Math.floor(m / 60);
  const rem = m % 60;
  if (h === 0) return `${rem}m`;
  return rem === 0 ? `${h}h` : `${h}h ${rem}m`;
};

// Accepts "90", "90m", "1h", "1h 30m", "1.5h", "1:30" -> minutes (null if unparseable/empty)
export const parseEstimate = (input) => {
  if (input === null || input === undefined) return null;
  const s = String(input).trim().toLowerCase();
  if (!s) return null;
  const colon = s.match(/^(\d+):(\d{1,2})$/);
  if (colon) return parseInt(colon[1], 10) * 60 + parseInt(colon[2], 10);
  const hm = s.match(/^(?:(\d+(?:\.\d+)?)\s*h(?:ours?|rs?)?)?\s*(?:(\d+)\s*m(?:in(?:utes?)?)?)?$/);
  if (hm && (hm[1] || hm[2])) {
    return Math.round((hm[1] ? parseFloat(hm[1]) * 60 : 0) + (hm[2] ? parseInt(hm[2], 10) : 0));
  }
  const bare = s.match(/^\d+$/);
  if (bare) return parseInt(s, 10);
  return null;
};
